import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Manage_User.css';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import Pagination from './Pagination.js';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Manage_Logistic_Form() {
    const token = localStorage.getItem("authToken") || null;
    const navigate = useNavigate();

    const [fuelFormList, setFuelFormList] = useState([]);
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortOrder, setSortOrder] = useState("desc");
    const [isLoading, setIsLoading] = useState(true);

    const fetchFuelFormList = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getLogisticForms`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('API Response:', data);

            // Access the 'data' array inside the response

            setFuelFormList(Array.isArray(data.data) ? data.data : []);
            setItems(Array.isArray(data.data) ? data.data : []);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching fuel forms:', error);
            setFuelFormList([]);
        }
    };

    useEffect(() => {
        fetchFuelFormList();
    }, [API_BASE_URL, token]);

    useEffect(() => {
        if (!Array.isArray(items)) {
            setFilteredItems([]);
            return;
        }

        const filtered = items.filter(item => {
            const name = item.name ? item.name.toLowerCase() : "";
            const id = item.id ? item.id.toLowerCase() : "";

            return (
                name.includes(searchQuery.toLowerCase()) ||
                id.includes(searchQuery.toLowerCase())
            );
        });

        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
            return 0;
        });

        setFilteredItems(sorted);
        setCurrentPage(1); // Reset to first page when items or search query changes
    }, [searchQuery, items, sortColumn, sortOrder]);


    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = e => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = pageNumber => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = e => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = column => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const handleDelete = async (id) => {
        // Show confirmation prompt
        const isConfirmed = window.confirm("Are you sure you want to delete this logistic form?");

        if (!isConfirmed) {
            // If the user clicks "Cancel", exit the function without doing anything
            return;
        }

        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}delete_logistic_form/${id}`, {
                method: 'POST',  // HTTP method
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {

                navigate('/manage_logistic_forms');
                window.location.reload();
                // Optionally, you can also update the UI after the deletion
                // For example, remove the deleted item from the list
            } else {
                alert("Failed to delete the logistic form.");
            }
        } catch (error) {
            console.error("Error deleting logistic form:", error);
            alert("There was an error while deleting the logistic form.");
        }
    };


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Logistic Forms List</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><Link to="/dashboard">Home</Link></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Logistic Forms List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                        <div className="card-header">
                                            <span style={{ float: 'right' }}>
                                                <Link to="/add_logistic_form">
                                                    <button type="button" className="btn btn-sm btn-success">Add New</button>
                                                </Link>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            {isLoading ? (
                                                <p>Loading...</p>
                                            ) : fuelFormList.length === 0 ? (
                                                <p>No logistic forms found.</p>
                                            ) : (
                                                <>
                                                    <div id="example1_filter" style={{ float: 'right' }} className="dataTables_filter">
                                                        <label>
                                                            <input
                                                                type="search"
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Search"
                                                                aria-controls="example1"
                                                            />
                                                        </label>
                                                    </div>

                                                    <div className="form-group">
                                                        <select
                                                            className="form-control custom-select-sm"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>

                                                    <div className="table-responsive">


                                                        <table className="table table-hover text-nowrap">
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th>
                                                                    <th>Trans Code</th>
                                                                    <th>Driver</th>
                                                                    <th>Submit Status</th>
                                                                    <th>Start Km</th>
                                                                    <th>End Km</th>
                                                                    <th>Total Km</th>
                                                                    <th>Total Repairs</th>
                                                                    <th>Total Bill Amount</th>
                                                                    <th>Rpt Mgr Status</th>
                                                                    {/* <th>Audit Status</th> */}
                                                                    {/* <th>Finance Status</th> */}
                                                                    <th>
                                                                        CreatedOn
                                                                    </th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentItems.length > 0 ? (
                                                                    currentItems.map((fuelForm, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {index +
                                                                                    1 +
                                                                                    (currentPage - 1) * itemsPerPage}
                                                                            </td>
                                                                            <td>{fuelForm.trans_code}</td>
                                                                            <td>{fuelForm.emp_code}</td>
                                                                            <td>{fuelForm.is_submitted}</td>
                                                                            
                                                                            <td>{Math.floor(fuelForm.start_kms)}</td>
                                                                            <td>{Math.floor(fuelForm.end_kms)}</td>
                                                                            <td>{Math.floor(fuelForm.sum_km)}</td>
                                                                            <td>{fuelForm.sum_repairs ? Math.floor(fuelForm.sum_repairs) : ""}</td>
                                                                            <td>{fuelForm.sum_bill ? Math.floor(fuelForm.sum_bill) : ""}</td>
                                                                            <td style={{ color: fuelForm.rpt_mgr_status === 'Pending' ? 'orange' : fuelForm.rpt_mgr_status === 'Rejected' ? 'red' : fuelForm.rpt_mgr_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                {fuelForm.rpt_mgr_status}
                                                                            </td>
                                                                            {/* <td style={{ color: fuelForm.audit_status === 'Pending' ? 'orange' : fuelForm.audit_status === 'Rejected' ? 'red' : fuelForm.audit_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                {fuelForm.audit_status}
                                                                            </td> */}
                                                                            {/* <td style={{ color: fuelForm.account_status === 'Pending' ? 'orange' : fuelForm.account_status === 'Rejected' ? 'red' : fuelForm.account_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                {fuelForm.account_status}
                                                                            </td> */}
                                                                            <td>
                                                                                {new Date(fuelForm.created_on)
                                                                                    .toLocaleDateString("en-GB")
                                                                                    .replace(/\//g, "-")}
                                                                            </td>
                                                                            <td> <Link to={`/edit_logistic_form/${fuelForm.id}`}>
                                                                                <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green', marginRight: '10px' }}></i>
                                                                            </Link>
                                                                            {(fuelForm.rpt_mgr_status === 'Pending' || fuelForm.rpt_mgr_status === 'Rejected' || fuelForm.audit_status === 'Rejected') && (
                                                                                        <i className="fa fa-trash" onClick={() => handleDelete(fuelForm.id)} style={{ marginRight: '10px', fontSize: '12px', color: 'green' }}></i>
                                                                                    )}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan='3'>No data available</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        handlePageChange={handlePageChange}
                                    />
                                    <div className="mb-3">
                                        Showing {startItem} to {endItem} of {filteredItems.length} entries
                                    </div>
                                </section>
                            </div>
                        </div>

                    </section>
                </div >
                <Footer />
            </div >
        </div >


    )
}

export default Manage_Logistic_Form